//prevent top menu links from being clicked

document.querySelectorAll('.primary-nav__link').forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault();
    });
});